// Brand font stack (IBM Plex Sans) for the TS/MUI layer, so the app-level and
// form-level themes cannot drift apart. The CSS layer declares the same stack
// independently: the `body` rule in index.css and Tailwind's
// `font-ibm-plex-sans` utility.
export const plex =
  '"IBM Plex Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif';
